import { ReactNode } from 'react';
import { Element, Icon } from 'react-bulma-components';
import styles from './admin-user-access-action-card.module.scss';

export type AdminUserAccessActionCardProps = {
  title: string;
  subtitle: string;
  icon: ReactNode;
  onClick: () => void;
};

export function AdminUserAccessActionCard({
  title,
  subtitle,
  icon,
  onClick,
}: AdminUserAccessActionCardProps) {
  return (
    <Element
      display="flex"
      flexDirection="column"
      className={`is-clickable ${styles.container}`}
      onClick={onClick}
      alignItems="center"
    >
      <span className="is-size-5 p-3">{title}</span>
      <Icon color="primary-dark" className={styles.iconContainer}>
        {icon}
      </Icon>
      <span className="is-size-7 p-4">{subtitle}</span>
    </Element>
  );
}

export default AdminUserAccessActionCard;
